"use client";

import type { ReactNode } from "react";

import { Toaster } from "@/shared/ui/shadcn-components/sonner";

interface SnackbarProviderProps {
  children: ReactNode;
}

/** App-wide toast host (sonner). Export name kept for AppProviders compat. */
export function SnackbarProvider({ children }: SnackbarProviderProps) {
  return (
    <>
      {children}
      <Toaster
        position="top-right"
        closeButton
        offset={16}
        gap={10}
        visibleToasts={3}
        toastOptions={{
          classNames: {
            toast:
              "cn-toast !rounded-xl !border !border-border !bg-popover !px-4 !py-3.5 !pr-10 !text-popover-foreground !shadow-md",
            title: "!text-[13px] !font-semibold !text-foreground",
            description: "!text-[12px] !text-muted-foreground",
            icon: "!text-muted-foreground",
            actionButton:
              "!rounded-md !bg-muted !px-3 !py-1.5 !text-[12px] !font-medium !text-foreground hover:!bg-muted/80",
            closeButton: "toast-close-btn",
            success: "[&_[data-icon]]:!text-success",
            error: "[&_[data-icon]]:!text-destructive",
            info: "[&_[data-icon]]:!text-primary",
            warning: "[&_[data-icon]]:!text-warning-foreground",
            loading: "[&_[data-icon]]:!text-muted-foreground",
          },
        }}
      />
    </>
  );
}
